import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../firebase";
import AuthShell, { inputClass, labelClass } from "./AuthShell";
import { friendlyAuthError } from "./Login";

const ResetPassword: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState<string | null>(null);
  const [sent, setSent] = useState(false);

  const submit = async () => {
    if (!email) return setMsg(t("auth.errors.invalidEmail"));
    try {
      await sendPasswordResetEmail(auth, email.trim());
      setSent(true);
      setMsg(t("auth.reset.sent"));
    } catch (e: any) {
      setMsg(friendlyAuthError(e?.code, t));
    }
  };

  return (
    <AuthShell
      title={t("auth.reset.title")}
      subtitle={t("auth.reset.subtitle")}
      icon="fa-key"
      onBack={() => history.push("/login")}
      backLabel={t("common.back")}
      alert={{
        open: Boolean(msg),
        header: t("common.information"),
        message: msg || "",
        onClose: () => {
          setMsg(null);
          if (sent) history.push("/login");
        },
        dismissLabel: t("common.close"),
      }}>
      <div className="space-y-4">
        <div className="space-y-2">
          <label className={labelClass}>
            <i className="fa-solid fa-envelope text-primary-400" />
            {t("auth.email")}
          </label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="prenom@exemple.ch" className={inputClass} />
        </div>
        <button type="button" onClick={submit} className="btn-primary w-full text-base uppercase tracking-wide">
          {t("auth.reset.button")}
        </button>
      </div>
    </AuthShell>
  );
};

export default ResetPassword;
